import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/classes')({
  component: ClassesLayout,
});

function ClassesLayout() {
  return <Outlet />;
}
